<script lang="tsx">
  import { defineComponent, PropType, computed } from 'vue'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import { REMOVE_PATH } from '@xhs/yam-beer/cmp/constants/builtinIcon'

  export default defineComponent({
    name: 'RemoveIcon',
    props: {
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
    },

    setup(props) {
      const computedBs = computed<BeerStyleObj>(() => ({
        bg: 'rgba(0,0,0, 0.6)',
        '&:hover': {
          bg: 'rgba(0,0,0, 0.7)',
        },
        '&:active': {
          bg: 'rgba(0,0,0, 0.8)',
        },
        size: '20px',
        borderRadius: 'control',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        appearance: 'none',
        outline: 'none',
        border: 'none',
        p: 0,
        ...props.bs,
      }))
      return () => (
      <NewBsBox
        bs={computedBs.value}
        as="button"
      >
        <BeerIcon
          iconPath={REMOVE_PATH}
          size={10}
          gridSize={10}
          // @ts-ignore
          color="white"
        />
      </NewBsBox>
    )
    },
  })
</script>
